import { useTranslation } from 'react-i18next'
import { useScrollReveal } from '@/hooks/use-scroll-reveal'
import Container from '@/components/ui/container'
import Button from '@/components/ui/button'
import Link from '@/components/ui/link'

export default function Cta() {
  const { t } = useTranslation()
  const { ref, visible } = useScrollReveal()

  return (
    <section
      ref={ref}
      className="py-16 md:py-24 lg:py-32 bg-surface-container-lowest relative overflow-hidden"
    >
      <div className="absolute top-0 right-0 w-1/2 h-full bg-primary/5 blur-[120px] rounded-full translate-x-1/2 -translate-y-1/2" />

      <Container className="relative z-10 text-center">
        <div className="max-w-3xl mx-auto">
          <h2
            className={`font-display text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-extrabold tracking-tighter mb-8 text-on-surface transition-all duration-700 ease-out ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            {t('cta.heading')}
          </h2>
          <p
            className={`text-on-surface-variant text-base md:text-lg lg:text-xl mb-8 md:mb-12 whitespace-pre-line transition-all duration-700 ease-out ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{ transitionDelay: visible ? '200ms' : '0ms' }}
          >
            {t('cta.description')}
          </p>
          <div
            className={`flex flex-col sm:flex-row justify-center gap-6 transition-all duration-700 ease-out ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{ transitionDelay: visible ? '400ms' : '0ms' }}
          >
            <Link href="/contact">
              <Button variant="gradient" size="lg">
                {t('cta.button')}
              </Button>
            </Link>
          </div>
        </div>
      </Container>
    </section>
  )
}
